import { render, staticRenderFns } from "./AddTaxCategoryModal.vue?vue&type=template&id=119c4250&"
import script from "./AddTaxCategoryModal.vue?vue&type=script&lang=js&"
export * from "./AddTaxCategoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports